import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { required } from "../../../util/validators";
import { ImportModal } from "../../components/ImportModal";

export const ImportPayorLabSettingsModal = ({ onImport, payorId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      payorId: values.payorId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/payor_lab_settings/import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Add Lab Network Statuses to Payors from CSV..."
      initialValues={{ payorId }}
      exampleDownloadPath="/admin/payors/lab_network_status_example_csv"
    >
      {(formProps) => <Field component={TextInput} name="payorId" type="hidden" required validate={required} />}
    </ImportModal>
  );
};
